import { render, staticRenderFns } from "./saleAreaDB.vue?vue&type=template&id=640f0652&scoped=true&"
import script from "./saleAreaDB.vue?vue&type=script&lang=js&"
export * from "./saleAreaDB.vue?vue&type=script&lang=js&"
import style0 from "./saleAreaDB.vue?vue&type=style&index=0&id=640f0652&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f0652",
  null
  
)

export default component.exports